document.addEventListener('DOMContentLoaded', function () {
 const slides = document.querySelectorAll('.slideshow__slide');

  slides.forEach((slide) => {
    slide.addEventListener('transitionstart', () => {
      if (slide.classList.contains('slideshow__slide--active')) {
        slide.querySelectorAll('.tw-opacity-0').forEach((el) => {
          el.classList.remove('tw-opacity-0');
          el.classList.add('tw-opacity-100');
        });
      } else {
        slide.querySelectorAll('.tw-opacity-100').forEach((el) => {
          el.classList.remove('tw-opacity-100');
          el.classList.add('tw-opacity-0');
        });
      }
    });
  });
});
